import { get } from 'lodash'

import { MISSION_STATUS_ENUM } from 'shared/constants'

export function isMatchingString(source, test) {
  let stringEscaped = test.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&')
  let stringArray = stringEscaped.split(' ')

  for (let i = 0; i < stringArray.length; i++) {
    if (stringArray[i].length > 0) {
      let regExpString = ''
      let regExp = null

      regExpString += `(?=.*${stringArray[i]}.*)`
      regExp = new RegExp(regExpString, 'gim')

      if (!regExp.test(source)) {
        return false
      }
    }
  }

  return true
}

export const compositionEqualMatching = (prop, check) => eachData =>
  !check ? true : get(eachData, prop) === check

/**
 * Function that compare 2 strings to get the similarity
 * @param {*} strA
 * @param {*} strB
 *
 * @returns the percentage of similarity of two string
 */
export function compareStringSimilarity(strA, strB) {
  for (var result = 0, i = strA.length; i--; ) {
    if (typeof strB[i] === 'undefined' || strA[i] === strB[i]);
    else if (strA[i].toLowerCase() === strB[i].toLowerCase()) result++
    else result += 4
  }
  return (
    1 -
    (result + 4 * Math.abs(strA.length - strB.length)) /
      (2 * (strA.length + strB.length))
  )
}

/**
 * Sorts option objects
 */
export const optionSortFunc = (c1, c2) => {
  if (c1.label < c2.label) return -1
  if (c1.label > c2.label) return 1
  return 0
}

/**
 * Check is ambassador have future missions.
 *
 * One of the ways to use.
 * Check or "TERMINATING" status.
 * If the ambassador status is "BLOCKED" and there are future missions.
 * Then change the status to "TERMINATING".
 */
export const futureMissionsCount = missions => {
  const currentData = new Date()

  return missions.filter(
    m =>
      m.status == MISSION_STATUS_ENUM.CHECKED_IN ||
      (m.status == MISSION_STATUS_ENUM.BOOKED &&
        new Date(m.dateTime) > currentData),
  ).length
}



// WEBPACK FOOTER //
// ./src/Utils/Filters/index.js